import React, { useReducer, useState, useContext } from 'react';
import api from './ApiCall';
import { COURSE_LIST, COURSE_DETAILS, CourseContext, CommonContext } from './../constant/ActionTypes';
import { courseReducer } from './../reducer/courseReducer';
import Loader from './../../common/Loader/Loader';

const initialState = {
    courseList: [],
    courseDetails: {}
}

const CourseProvider = (props) => {
    const commonContext = useContext(CommonContext);

    const [courseState, dispatch] = useReducer(courseReducer, initialState);

    const [showLoader, setShowLoader] = useState(false);

    const getCourseList = (page=null, offset=null) => {
        let pageLink = '';
        if (page) {
            pageLink = `?page=${page}&itemSize=${offset}`;
        }

        api({ contentType: true, auth: true }).get(`CourseService/getAll${pageLink}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: COURSE_LIST,
                    payload: response.data.result && response.data.result.content ? response.data.result.content : response.data.result
                });
                commonContext.updatePagination(response.data.result);
                if (
                    !(response.data.result && response.data.result.length > 0) ||
                    !(response.data.result && response.data.result.content && response.data.result.content.length > 0)
                ) {
                    commonContext.updateLoaderMsg('No data found')
                }
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const clearCourseList = () => {
        dispatch({
            type: COURSE_LIST,
            payload: []
        });
    }
    
    const clearCourseDetails = () => {
        dispatch({
            type: COURSE_DETAILS,
            payload: {}
        });
    }

    const getCourseDetails = (id) => {
        api({ contentType: true, auth: true }).get(`CourseService/getDetails/${id}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                dispatch({
                    type: COURSE_DETAILS,
                    payload: response.data.result
                });
            }
        })
        .catch((error) => {
            console.log(error);
        });
    }

    const addCourseDetails = (data) => {
        setShowLoader(true);
        // console.log(data, 'data');
        api({ contentType: true, auth: true }).post('CourseService/add', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getCourseList(1, 25);
                commonContext.handleSnackbar(true, 'success', 'Course added successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Course cannot be added');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Course cannot be added');
            }
        });
    }

    const updateCourseDetails = (data) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch('CourseService/update', data)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getCourseList(1, 25);
                commonContext.handleSnackbar(true, 'success', 'Course updated successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Course cannot be updated');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Course cannot be updated');
            }
        });
    }

    const deleteCourse = (courseId) => {
        setShowLoader(true);
        api({ contentType: true, auth: true }).patch(`CourseService/delete/${courseId}`)
        .then((response) => {
            if(response.data.status.toLowerCase() === 'success') {
                getCourseList(1, 25);
                commonContext.handleSnackbar(true, 'success', 'Course deleted successfully');
            } else {
                commonContext.handleSnackbar(true, 'error', 'Course cannot be deleted');
            }
            setShowLoader(false);
        })
        .catch((error) => {
            console.log(error);
            setShowLoader(false);
            if(error.response) {
                commonContext.handleSnackbar(true, 'error', 'Course cannot be deleted');
            }
        });
    }

    return (
        <CourseContext.Provider
            value={{
                ...courseState,
                getCourseList: getCourseList,
                getCourseDetails: getCourseDetails,
                clearCourseDetails: clearCourseDetails,
                deleteCourse: deleteCourse,
                updateCourseDetails: updateCourseDetails,
                addCourseDetails: addCourseDetails,
                clearCourseList: clearCourseList
            }}
        >
            {props.children}
            {showLoader && <Loader onlyLoading />}
        </CourseContext.Provider>
    );
}

export default CourseProvider;



// WEBPACK FOOTER //
// ./contexts/provider/CourseContext.js